import { Symptoms } from 'types';
import { IPetHistory } from 'types/PetHistory';
import { formatDateToBR, formatHour } from 'util/masks';

export const transformPetHistory = (list: IPetHistory[]) => {
  if (!Array.isArray(list)) {
    return [];
  }

  return list.map((history) => ({
    ...history,
    id: history._id,
    date: formatDateToBR(history.createdAt),
    hour: formatHour(history.createdAt),
  }));
};

/**
 * Fiter symptoms by classification
 *
 * @param {Symptoms[]} symptoms
 * @param {Symptoms['classification']} classification
 * @return {*}
 */
const filterSymtomByClassification = (
  symptoms: Symptoms[],
  classification: Symptoms['classification']
) => {
  return symptoms.filter(
    (symptom) => symptom.classification === classification
  );
};

/**
 * Sort symptoms by risk classigication, from high to low priority
 *
 * @param {Symptoms[]} symptoms
 * @return {*}
 */
export const sortSymtomsByClassifications = (symptoms: Symptoms[]) => {
  if (!Array.isArray(symptoms)) {
    return [];
  }

  const emergency = filterSymtomByClassification(symptoms, 'EMERGENCY');
  const urgency = filterSymtomByClassification(symptoms, 'URGENCY');
  const routineConsultation = filterSymtomByClassification(
    symptoms,
    'ROUTINE_CONSULTATION'
  );

  return emergency.concat(urgency).concat(routineConsultation);
};

